import objectFitImages from 'object-fit-images';

objectFitImages();
